import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'
import _imports_1 from '../../assets/images/logo-white.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-ce0f3954"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-close-fill" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-8 col-md-9\" data-v-ce0f3954><div class=\"header-top-left\" data-v-ce0f3954><ul class=\"contact-info list-style\" data-v-ce0f3954><li data-v-ce0f3954><i class=\"flaticon-call\" data-v-ce0f3954></i><a href=\"tel:02459271449\" data-v-ce0f3954>(+229) 21 31 79 58</a></li><li data-v-ce0f3954><i class=\"flaticon-email-1\" data-v-ce0f3954></i><a href=\"mailto:contact@laposte.bj\" data-v-ce0f3954>contact@laposte.bj</a></li><li data-v-ce0f3954><i class=\"flaticon-pin\" data-v-ce0f3954></i><p data-v-ce0f3954>Route du port, Cotonou, Bénin</p></li></ul></div></div>", 1)
const _hoisted_6 = { class: "col-lg-4 col-md-3" }
const _hoisted_7 = { class: "header-top-right" }
const _hoisted_8 = { class: "header-top-menu list-style" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://shake.o2switch.net:2096",
    target: "_blank"
  }, "Webmail")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    a: "",
    href: "http://41.85.184.12/webtracking",
    class: "nav-link",
    target: "_blank"
  }, "Suivi de colis")
], -1))
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = {
  a: "",
  href: "javascript:void(0);",
  class: "nav-link"
}
const _hoisted_13 = { class: "header-bottom" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "navbar navbar-expand-md navbar-light" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-light headerimg",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-dark headerimg",
  src: _imports_1,
  alt: "logo"
}, null, -1))
const _hoisted_18 = { class: "navbar-nav ms-auto" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item has-dropdown" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "nav-link"
}, [
  /*#__PURE__*/_createTextVNode(" Nos Services "),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line" })
], -1))
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "nav-link"
}, [
  /*#__PURE__*/_createTextVNode(" Services Postaux "),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line" })
], -1))
const _hoisted_25 = { class: "dropdown-menu" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = { class: "nav-item" }
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "nav-link"
}, [
  /*#__PURE__*/_createTextVNode(" Services Financiers "),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line" })
], -1))
const _hoisted_33 = { class: "dropdown-menu" }
const _hoisted_34 = { class: "nav-item" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = { class: "nav-item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "nav-link"
}, [
  /*#__PURE__*/_createTextVNode(" Services connexes "),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line" })
], -1))
const _hoisted_40 = { class: "dropdown-menu" }
const _hoisted_41 = { class: "nav-item" }
const _hoisted_42 = { class: "nav-item" }
const _hoisted_43 = { class: "nav-item" }
const _hoisted_44 = { class: "nav-item" }
const _hoisted_45 = { class: "nav-item has-dropdown" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "nav-link"
}, [
  /*#__PURE__*/_createTextVNode(" e-Services "),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line" })
], -1))
const _hoisted_47 = { class: "dropdown-menu" }
const _hoisted_48 = { class: "nav-item" }
const _hoisted_49 = { class: "nav-item" }
const _hoisted_50 = { class: "nav-item" }
const _hoisted_51 = { class: "nav-item" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    a: "",
    href: "http://boutique.nostests.com",
    class: "nav-link",
    target: "_blank"
  }, "Boutique")
], -1))
const _hoisted_53 = { class: "nav-item has-dropdown" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "nav-link"
}, [
  /*#__PURE__*/_createTextVNode(" Médiathèques "),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line" })
], -1))
const _hoisted_55 = { class: "dropdown-menu" }
const _hoisted_56 = { class: "nav-item" }
const _hoisted_57 = { class: "nav-item" }
const _hoisted_58 = { class: "nav-item" }
const _hoisted_59 = { class: "nav-item" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-options d-flex align-items-cente" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-btn" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://bp.laposte.bj/",
      class: "btn btn-sm style1 fs16",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("b", null, "E-boîte postale")
    ])
  ])
], -1))
const _hoisted_61 = { class: "mobile-bar-wrap" }
const _hoisted_62 = ["aria-pressed"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-menu-4-line" }, null, -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["aria-pressed"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search" }, null, -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = ["aria-pressed"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-menu-line" }),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-close-line" })
], -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { class: "container" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "search",
    placeholder: "Search Here",
    autofocus: ""
  })
], -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-close-line" }, null, -1))
const _hoisted_75 = [
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['header-wrap', { sticky: _ctx.isSticky }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-top", { open: _ctx.open }])
    }, [
      _createElementVNode("button", {
        type: "button",
        class: "close-sidebar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
      }, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/faq" }, {
                    default: _withCtx(() => [
                      _createTextVNode("FAQ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_10,
                _createElementVNode("li", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.totalVisiteurs) + " Visiteurs", 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("nav", _hoisted_15, [
          _createVNode(_component_router_link, {
            class: "navbar-brand",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _hoisted_17
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["collapse navbar-collapse", { show: _ctx.active }])
          }, [
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", _hoisted_19, [
                _createVNode(_component_router_link, {
                  to: "/about",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("A Propos")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("ul", _hoisted_22, [
                  _createElementVNode("li", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("ul", _hoisted_25, [
                      _createElementVNode("li", _hoisted_26, [
                        _createVNode(_component_router_link, {
                          to: "/colisPostaux",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Colis postaux")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createVNode(_component_router_link, {
                          to: "/envoisExpress",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Envois Express")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_28, [
                        _createVNode(_component_router_link, {
                          to: "/philatelie",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Philatélie")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_29, [
                        _createVNode(_component_router_link, {
                          to: "/posteLettre",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Poste aux lettres")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_30, [
                        _createVNode(_component_router_link, {
                          to: "/serviceDistribution",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Service distribution")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("ul", _hoisted_33, [
                      _createElementVNode("li", _hoisted_34, [
                        _createVNode(_component_router_link, {
                          to: "/assurances",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Assurances")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_35, [
                        _createVNode(_component_router_link, {
                          to: "/centreCheque",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Produits du Centre de Chèques Postaux (CCP)")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_36, [
                        _createVNode(_component_router_link, {
                          to: "/caisseNational",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Produit de la Caisse Nationale d'Epargne")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_37, [
                        _createVNode(_component_router_link, {
                          to: "/transfertArgent",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Transferts d'argent et finance digitale")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("ul", _hoisted_40, [
                      _createElementVNode("li", _hoisted_41, [
                        _createVNode(_component_router_link, {
                          to: "/posteVerte",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Initiative Poste Verte")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_42, [
                        _createVNode(_component_router_link, {
                          to: "/posteVoyage",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Poste Voyages")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_43, [
                        _createVNode(_component_router_link, {
                          to: "/produitPartenariat",
                          class: "nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Produits de partenariat")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_44, [
                    _createVNode(_component_router_link, {
                      to: "produitColisPostaux",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tarification")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("ul", _hoisted_47, [
                  _createElementVNode("li", _hoisted_48, [
                    _createVNode(_component_router_link, {
                      to: "/servicePoste",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("e-Services de la Poste")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_49, [
                    _createVNode(_component_router_link, {
                      to: "/servicePublic",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("e-Services publics")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_50, [
                    _createVNode(_component_router_link, {
                      to: "/faqeservice",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("FAQ e-Services")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_51, [
                _createVNode(_component_router_link, {
                  to: "/actualite",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Actualités")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_52,
              _createElementVNode("li", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("ul", _hoisted_55, [
                  _createElementVNode("li", _hoisted_56, [
                    _createVNode(_component_router_link, {
                      to: "/mediatheque",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Galerie Photos")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_57, [
                    _createVNode(_component_router_link, {
                      to: "/mediathequeVideo",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Galerie Vidéos")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_58, [
                    _createVNode(_component_router_link, {
                      to: "/document",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Document")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_59, [
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Contact")
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_60
          ], 2),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", {
              class: _normalizeClass(["mobile-sidebar", { open: _ctx.button_open_state }]),
              onClick: [
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = !_ctx.open)),
                _cache[2] || (_cache[2] = ($event: any) => (_ctx.button_open_state = !_ctx.button_open_state))
              ],
              "aria-pressed": _ctx.open ? 'true' : 'false'
            }, _hoisted_64, 10, _hoisted_62),
            _createElementVNode("button", {
              class: _normalizeClass(["searchbtn", { search: _ctx.button_search_state }]),
              type: "button",
              onClick: [
                _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = !_ctx.search)),
                _cache[4] || (_cache[4] = ($event: any) => (_ctx.button_search_state = !_ctx.button_search_state))
              ],
              "aria-pressed": _ctx.search ? 'true' : 'false'
            }, _hoisted_67, 10, _hoisted_65),
            _createElementVNode("div", {
              class: _normalizeClass(["navbar-toggler mobile-menu xl-none", { active: _ctx.button_active_state }]),
              onClick: [
                _cache[5] || (_cache[5] = ($event: any) => (_ctx.active = !_ctx.active)),
                _cache[6] || (_cache[6] = ($event: any) => (_ctx.button_active_state = !_ctx.button_active_state))
              ],
              "aria-pressed": _ctx.active ? 'true' : 'false'
            }, _hoisted_70, 10, _hoisted_68)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["search-area", { search: _ctx.search }])
      }, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
          }, _hoisted_73, 32),
          _createElementVNode("button", {
            type: "button",
            class: "close-searchbox",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.search = !_ctx.search))
          }, _hoisted_75)
        ])
      ], 2)
    ])
  ], 2))
}